export const klaroConfig = {
    // You can customize the ID of the DIV element that Klaro will create
    // when starting up. If undefined, Klaro will use 'klaro'.
    elementID: 'klaro',

    // You can customize the name of the cookie that Klaro uses for storing
    // user consent decisions. If undefined, Klaro will use 'klaro'.
    cookieName: 'klaro',

    // You can also set a custom expiration time for the Klaro cookie.
    // By default, it will expire after 120 days.
    cookieExpiresAfterDays: 365,

    // Put a link to your privacy policy here (relative or absolute).
    privacyPolicy: '/de/datenschutz',

    // Defines the default state for applications (true=enabled by default).
    default: false,

    // If "mustConsent" is set to true, Klaro will directly display the consent
    // manager modal and not allow the user to close it before having actively
    // consented or declines the use of third-party apps.
    mustConsent: true,

    // Show "accept all" to accept all services instead of "ok" that only accepts
    // required and "default: true" services
    acceptAll: true,

    translations: {
        de: {
            acceptAll: "Alle annehmen",
            acceptSelected: "Ausgewählte annehmen",
            decline: "Ablehnen",
            ok: "Alle Akzeptieren",
            purposes: {
                analytics: 'Besucher-Statistiken',
                technical: 'Bereitstellung der Website',
                external: 'Bereitstellung eines externen Dienstes'
            },
            googleAnalytics: {
                description: 'Sammeln von Besucherstatistiken',
            },
            googleMaps: {
                description: 'Bereitstellen einer eingebetteten Google Maps Karte, die eine Verbindung zu Google-Servern herstellt.',
            },
            userSessionCookie: {
                description: 'Automatisches Setzen eines erforderlichen Session Cookies, welcher von dieser Website benötigt wird',
            },
        },
        en: {
            decline: "Decline",
            purposes: {
                analytics: 'Analytics',
                technical: 'Technical requirement'
            },
            googleAnalytics: {
                description: 'Collection of visitor statistics via Google Analytics',
            },
            googleMaps: {
                description: 'Providing an embedded Google Maps which requires a connection to Google servers.',
            },
            userSessionCookie: {
                description: 'Automatic setting of an encrypted session cookie required by this website and its content management system',
            },
        },
    },

    apps: [
        {
            name: 'googleAnalytics',
            title: 'Google Analytics',
            purposes: ['analytics'],
            cookies: [
                [/^_ga.*$/, '/', 'hsw-sylt.de'], // for the production version
                [/^_gat.*$/, '/', 'hsw-sylt.de'], // for the production version
                [/^_gid.*$/, '/', 'hsw-sylt.de'], // for the production version
                [/^_ga.*$/, '/', 'localhost'], // for the local version
                [/^_gat.*$/, '/', 'localhost'], // for the local version
                [/^_gid.*$/, '/', 'localhost'], // for the local version
            ],
            required: false,
            optOut: false,
            onlyOnce: true,
        },
        {
            name: 'googleMaps',
            title: 'Google Maps',
            purposes: ['external'],
            required: false,
            optOut: false,
            onlyOnce: true,
        },
        {
            name: 'userSessionCookie',
            required: true,
            title: 'Session-Cookie',
            purposes: ['technical'],
        },
    ],
};
